import { IconCamera } from '@tabler/icons-react';
import React, { useState } from 'react'

const ImageUpload = () => {

    const [image, setImage] = useState('')

    const imageUpload = (e) => {
        const file = e.target.files[0];
        console.log(file);
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.readyState === 2) {
            console.log(reader.result);
            setImage(reader.result);
          }
        };
        reader.readAsDataURL(file);
    }

  return (
    <div className='flex justify-center'>
        <div className="w-[60px] h-[60px] rounded-full relative">
        <img 
        src={image || 'https://as1.ftcdn.net/v2/jpg/05/99/32/28/1000_F_599322870_hufBazDahX69a57xhcprgfn4WSjAlXZj.jpg'} 
        alt="avatar" 
        className="w-[60px] h-[60px] rounded-full border-2 border-primary p-[2px]" 
        />
        {
            !image &&
            <div className="absolute top-0 left-0 w-full h-full bg-black opacity-60 rounded-full">
                <IconCamera size={20} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white" />
            </div>
        }
        <input
        onChange={imageUpload} 
        type="file" 
        className="opacity-0 absolute top-0 left-0 w-[60px] h-[60px]" 
        />
    </div>
    </div>
  )
}

export default ImageUpload